<template>
  <b-card
    no-body
    v-draggable
    ref="autocasion_subcard"
    id="autocasion-subcard"
  >
    <!-- Header -->
    <b-card-header
      style="color: lightgrey; height: 25px; cursor: move"
      class="pl-2 pb-0 pt-0"
      header-tag="div"
      header-bg-variant="dark"
    >
      <b-row class="mx-0 px-0">
        <b-col class="mx-0 px-0" cols="11">
          Autocasion
          <span v-if="isCompetitor"
            >-
            {{ $t("Webportal.CX.Dashboard.Exploration.Competitor") }}</span
          >
        </b-col>
        <b-col class="mx-0 px-0" cols="1" style="text-align: right">
          <font-awesome-icon
            class="mx-1 clickable"
            :icon="['far', 'times']"
            @click="close()"
          />
        </b-col>
      </b-row>
    </b-card-header>

    <!-- Content -->
    <div v-if="isLoading" :class="{ spinner: isLoading }" style="height:200px"></div>
    <b-card-text
      v-else-if="AutocasionData != null" 
      class="pl-3 pr-3" 
      style="overflow: auto"
    >
      <!-- Top menu -->
      <b-row>
        <b-col cols="11" class="subcard-title mb-3">
          {{ headLine || AutocasionData.Name }}
        </b-col>
      </b-row>
      <b-button-group v-if="!isCompetitor">
        <CompetititorDropbox
          v-if="
            AutocasionData.Competitors &&
            AutocasionData.Competitors.length > 0
          "
          :competitorList="AutocasionData.Competitors"
          @openCompetitor="openCompetitor"
        />
        <b-button target="_blank" rel="noopener" :href="AutocasionData.WebsiteURL">
          <font-awesome-icon
            style="height: 15px; width: 15px"
            :icon="['far', 'external-link']"
          />
          {{ $t("Webportal.CX.Explorations.Autocasion.AutocasionLink")}}
        </b-button>
      </b-button-group>

      <!-- Ratings -->
      <template v-if="!isCompetitor">
        <ScoresChart :Scores="AutocasionData.OverallScores" :Width="620" v-if="AutocasionData.OverallScores"/>
        <hr>

        <b-row v-if="AutocasionData.Ratings">
          <b-col>
          <table class="table mb-0">
          <tr >
            <th class="border-top-0">{{ $t("Webportal.CX.Explorations.RatingsLabel") }}</th>
            <th class="border-top-0" colspan="3">{{ $t("Webportal.CX.Dashboard.Exploration.History") }}</th>
            <th class="border-top-0" colspan="3">{{ $t("Webportal.CX.Dashboard.Exploration.CurrentValue") }}</th>
          </tr>
            <template v-for="item in AutocasionData.Ratings">
              <RatingTableRow
                :key="item.title"
                :Title="item.RatingTypeName"
                :translationPrefix="'Webportal.CX.Dashboard.Exploration.Autocasion.'"
                :Ratings="item.RatingTypeResults" />
            </template>
          </table>
          </b-col>
        </b-row>
        <hr>
      </template>
      <template v-else>
        <div class="overallscore mb-3">
          <span class="label">{{ $t("Webportal.CX.Exploration.OverallScore")}}</span>
          <span class="value">{{AutocasionData.Autocasion.Ratings.find(r => r.Name == 'OverallScore').Value}} <b-icon icon="star-fill" class="text-warning"></b-icon></span>
        </div>


        <table class="table">
          <thead>
            <tr>
              <th class="border-top-0">{{ $t("Webportal.CX.Explorations.RatingsLabel") }}</th>
              <th class="border-top-0" colspan="2">{{ $t("Webportal.CX.Dashboard.Exploration.CurrentValue") }}</th>
            </tr>
          </thead>
          <template v-for="(rating) in AutocasionData.Autocasion.Ratings.filter(r => r.Name != 'OverallScore')">
            <CompetitorRatingTableRow :rating="rating" :key="rating.Name" :translationPrefix="'Webportal.CX.Dashboard.Exploration.Autocasion.'"/>
          </template>
        </table>
        
        <hr>
      </template>

      <!-- Reviews -->
      <div v-if="Reviews.length <= 0" class="pb-3">
        {{ $t("Webportal.CX.Dashboard.Exploration.NoReviews") }}
      </div>

      <div v-else>
        <p style="color: grey; font-size: 0.9rem">
          {{ ReviewCount }}
          {{ $t("Webportal.CX.Dashboard.Exploration.Reviews") }}
        </p>
        <p>{{ $t("Webportal.CX.Dashboard.Exploration.LatestReviews") }}:</p>
        <div class="pb-4" style="overflow: auto; height: 50%">
          <Accordion
            v-for="(review, index) in Reviews"
            :key="index"
            :toggleCols="1"
            class="mb-2"
          >
            <b-row slot="short" class="mb-2" style="width: 100%">
              <b-col>
                <b-row
                  class="m-0 p-0"
                  style="font-size: 0.9rem; font-weight: 600; line-height: 1"
                >
                  <b-col class="m-1 p-0 ml-n1">
                    <span>{{ review.AuthorName }}</span>
                  </b-col>
                </b-row>
                <b-row class="m-0 p-0 ml-n4 mb-n2" style="line-height: 1">
                  <b-col>
                    <b-form-rating
                      variant="warning"
                      class="m-0 p-0"
                      no-border
                      readonly
                      size="sm"
                      :value="review.Rating"
                    />
                  </b-col>
                  <b-col class="m-0 p-0" cols="4" style="display: flex">
                    <span>({{ new Date(review.Time).toLocaleDateString() }})</span>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>

            <!-- Accordion -->
            <template slot="long">
              <!-- Review text message -->
              <p class="mb-2" v-if="review.Text">
                {{ review.Text }}
              </p>

              <!-- Reply of retailer -->
              <div v-if="review.ReplyText">
                <hr v-if="review.Text" />
                <h6>Reply of retailer:</h6>
                <p class="mb-2">
                  {{ review.ReplyText }}
                </p>
              </div>
            </template>
          </Accordion>
        </div>
      </div>
    </b-card-text>
  </b-card>
</template>

<script>
import Accordion from "../Accordion";
import RatingDistribution from "./RatingDistribution";
import DashboardService from "@/services/DashboardService";
import RatingTableRow from "@/components/CX/ExplorationCard/RatingTableRow";
import ScoresChart from "@/components/CX/ExplorationCard/ScoresChart";

import CompetititorDropbox from "./CompetitorDropbox";

export default {
  name: "AutocasionPopup",
  components: {
    Accordion,
    RatingDistribution,
    CompetititorDropbox,
    RatingTableRow,
    ScoresChart
  },
  props: {
    autocasionData: {
      type: Object,
      default: () => {},
    },
    headLine: String,
    isCompetitor: Boolean,
    competitorId: Number,
  },
  data() {
    return {
      AutocasionData: null,
      AutocasionLastRating: {},
      isLoading: true
    };
  },

  computed: {
    _() {
      return _;
    },
    ReviewCount: function () {
      return (
        this.RatingsByName?.ReviewCount?.Value || this.Reviews?.length || 0
      );
    },
    Reviews: function () {
      return (
        this.AutocasionData?.Reviews ||
        this.AutocasionData?.Autocasion?.Reviews ||
        []
      );
    },
    Ratings: function () {
      return (
        this.AutocasionData?.Ratings ||
        this.AutocasionData?.Autocasion?.Ratings ||
        []
      );
    },
    RatingsByName: function () {
      return (
        this.AutocasionData?.RatingsByName ||
        this.AutocasionData?.Autocasion?.RatingsByName ||
        {}
      );
    },
    OverallScore: function () {
      return (
        this.AutocasionData?.Threshold?.Value ||
        this.RatingsByName?.OverallScore?.Value ||
        0
      );
    },
  },
  created: function() {
    window.addEventListener('keyup', this.handleKeyUp);
  },
  mounted: function () {
    if (this.isCompetitor) {
      this.getCompetitor(this.competitorId).then((response) => {
        this.AutocasionData = response.data;

        if (this.AutocasionData.Autocasion) {
          this.AutocasionData.Autocasion.RatingsByName = _.keyBy(
            this.AutocasionData.Autocasion.Ratings,
            "Name"
          );
        }
      })
      .finally(() =>{
        this.isLoading = false;
      });
    } else {
      this.AutocasionData = { ...this.autocasionData };
      // use setTimeout() to await next event cycle/finished building
      window.setTimeout(() => {this.isLoading = false}, 0);
    }
  },
  methods: {
    openCompetitor(id) {
      this.$emit("open-competitor", id);
    },
    getCompetitor(competitorId) {
      return DashboardService.getCompetitor(competitorId, { autocasion: true });
    },
    close() {
      window.removeEventListener('keyup', this.handleKeyUp);
      this.$emit('close');
    },
    handleKeyUp(event) {
      if (event.key == 'Escape') {
        this.close();
      }
    },
  },
};
</script>

<style scoped>
.subcard-title {
  font-size: 1.5rem;
}
#autocasion-subcard {
  position: fixed !important;
}
</style>
